export default __webpack_public_path__ + "static/taskdefinition_06-33844d8523a8c0402e25875a93dac071.png";